import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";

export const useSwal = () => {
  const { t } = useTranslation('common');

  const showAlert = useCallback(async (options) => {
    // Validar propiedades esenciales
    if (!options.title) {
      throw new Error(t('validation.titleRequired'));
    }
    // if (!options.text) {
    //   throw new Error("La propiedad 'text' es obligatoria.");
    // }

    const defaultOptions = {
      icon: false, // Sin icono por defecto
      showCancelButton: true,
      showDenyButton: false, // Por defecto, no se muestra el botón "No"
      confirmButtonText: t('actions.accept'),
      cancelButtonText: t('actions.cancel'),
      confirmButtonColor: "#3085d6",
      denyButtonColor: "#FF5252",
      cancelButtonColor: "#d33",
    };

    const finalOptions = {
      ...defaultOptions,
      ...options,
      ...(options.icon !== undefined ? { icon: options.icon } : {}),
      showDenyButton: options.denyButtonText ? true : false,

    };

    const result = await Swal.fire(finalOptions);
    return result;
  }, []);

  return showAlert;
};
